import { html, css } from "lit";
import { customElement, property, query, state } from "lit/decorators.js";
import { BaseVisualization, ReportEvent } from "./baseVisualization";
import { msg } from "@omegagrid/localize";
import { ReportResult } from "../../model";
import { ContextData } from "@reporting/rp-types/analytics";

@customElement('rp-visual-blank')
export class BlankVisualization extends BaseVisualization {

	static styles = css`
		:host, div.body {
			display: block;
			width: 100%;
			height: 100%;
			position: relative;
		}
	`;

	@query('div.body')
	body: HTMLDivElement;

	@property({type: Object})
	result: ReportResult;

	@state()
	empty = false;

	refresh(contextData?: ContextData) {
		super.refresh(contextData);
		this.runScripts();
		this.dispatchEvent(new ReportEvent('load'));
	}

	updated() {
		this.refresh();
	}

	render = () => this.empty ? html`
		<div class="msg">
			<og-alert type="warning" .text="${msg('No data available')}"></og-alert>
		</div>
	` : html`
		<div class="body"></div>
	`;

	layout() { }

}
